// src/services/supabase.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Only create client if we have valid credentials
export const supabase = supabaseUrl && supabaseKey && 
  supabaseUrl.startsWith('https://') && 
  supabaseKey.length > 20
  ? createClient(supabaseUrl, supabaseKey)
  : null;

// Helper function to check if Supabase is configured
export const isSupabaseConfigured = () => {
  return supabase !== null;
};

// Database schema - Note: Tables should be created manually using the SQL schema
// The myclassboard_ prefixed tables need to be created in your Supabase dashboard
// using the provided supabase_tables_schema.sql file